<div class="local-checklist-dialog">
  <div class="local-checklist-dialog__header">
    <span class="local-checklist-dialog__title">Создание чек-листа</span>
    <app-icon class="local-checklist-dialog__close-icon" [size]="'24'" [glyph]="'close'" (click)="activeModal.close()"></app-icon>
  </div>

  <div class="local-checklist-dialog__content">
    <form [formGroup]="form" class="local-checklist-dialog__form">
      <app-field class="local-checklist-dialog__control">
        <input class="input-text" placeholder="Введите название чек-листа" maxlength="150" formControlName="name" />
      </app-field>

      <ui-multicombobox
        class="local-checklist-dialog__control"
        textKey="name"
        defaultText="Тип заявки из HD"
        name="checklist-type-dialog"
        (callback)="handleChangeTicketType($event)"
        [items]="hdTicketTypes | func: cloneDeep"
        [initBy]="selectedHDTicketTypes"
        [nullChoice]="false"
        [sortByFn]="sortBySelected"
        [isDisabled]="false"
      >
      </ui-multicombobox>
    </form>
  </div>

  <div class="local-checklist-dialog__footer">
    <div class="local-checklist-dialog__actions">
      <button type="submit" class="button local-checklist-dialog__submit" (click)="handleSubmit()" [disabled]="form.invalid">Сохранить</button>
      <a class="link link--dotted-gray-dark local-checklist-dialog__cancel" (click)="activeModal.close()"> Отмена </a>
    </div>
  </div>
</div>
